import ModalWithContent from "../../../components/ModalWithContent";

export default function VercelBillingModal({
  vercelInstallationUrl,
  onClose,
}: {
  vercelInstallationUrl: string;
  onClose: () => void;
}): React.ReactElement | null {
  return (
    <ModalWithContent
      content={{
        title: "Change plan",
        message: "You can change your plan from the Vercel dashboard.",
        buttonText: "Open Vercel dashboard",
        closeText: "",
        intent: "PRIMARY",
      }}
      onClose={onClose}
      onSave={() => {
        window.open(vercelInstallationUrl, "_blank");
      }}
    />
  );
}
